import { Channel } from './onboardingmetadata/Channel';
import { DistributionPartner } from './onboardingmetadata/DistributionPartner';
import { Platform } from './onboardingmetadata/Platform';
export const OnboardingMetadata = {
    channel: Channel,
    distribution_partner: DistributionPartner,
    platform: Platform,
};
